import DOMPurify from "dompurify";
import ReactDOM from "react-dom/client";
import { Fragment, createElement, useState, useRef, useEffect } from "react";

import { confirmDialog } from "./components/ConfirmDialog";

window.bundle = {
	DOMPurify,
	ReactDOM,
	createElement,
	useState,
	useRef,
	useEffect,
	Fragment,
	confirmDialog,
};
